import React from 'react'
import Navbar from './Components/Portfolio/Navbar'
import "./Components/Portfolio/Index.css"
export default function App() {
  return (
    <div>
       <Navbar/>
    </div>
  )
}